import DocMenuConfig from "@/core/config/MainMenu2Config";
import LaporanMenuConfig from "@/core/config/MainMenu3Config";

export const PerkhidmatanMenuItems = [
    {
      icon: "/media/icons/duotune/abstract/abs027.svg",
      color: "success",
      title: "Dashboard",
      link: "/perkhidmatan/dashboard",
      name: "perkhidmatan-dashboard",
      description: "Project Manager",
      ctrl: "perkhidmatan_dashboard",
    },
    {
      icon: "/media/icons/duotune/communication/com005.svg",
      color: "success",
      title: "Jenis Permohonan",
      link: "/perkhidmatan/jenis-permohonan",
      name: "perkhidmatan-jenis-permohonan",
      description: "Jenis Permohonan",
      ctrl: "jenis-permohonan",
    },
    {
      icon: "/media/icons/duotune/files/fil010.svg",
      color: "success",
      title: "Penyediaan Calon",
      link: "/perkhidmatan/penyediaan_calon",
      name: "penyediaan-calon",
      description: "Art Director",
      ctrl: "penyediaan_calon",
    },
    {
      icon: "/media/icons/duotune/art/art005.svg",
      color: "warning",
      title: "Urusan Kenaikan Pangkat",
      link: "/perkhidmatan/kenaikan_pangkat",
      name: "naikpangkatlist3",
      description: "Art Director",
      ctrl: "kenaikan_pangkat",
    },
    {
      icon: "/media/icons/duotune/coding/cod008.svg",
      color: "danger",
      title: "Pergerakan",
      link: "/perkhidmatan/pergerakan",
      name: "pergerakanpegawai",
      description: "DevOps",
      ctrl: "pergerakan",
    },
     {
      icon: "/media/icons/duotune/general/gen049.svg",
      color: "secondary",
      title: "Pergerakan Pegawai",
      link: "/perkhidmatan/sejarah/pergerakan-pegawai",
      name: "pergerakan-pegawai",
      description: "QA Managers",
      ctrl: "pergerakan_pegawai",
    },
    {
      icon: "/media/icons/duotune/general/gen049.svg",
      color: "secondary",
      title: "Sejarah Pergerakan",
      link: "/perkhidmatan/sejarah/pergerakan",
      name: "pergerakan",
      description: "QA Managers",
      ctrl: "sejarah_pergerakan",
    },
    {
      icon: "/media/icons/duotune/files/fil010.svg",
      color: "success",
      title: "Perjawatan",
      link: "/perkhidmatan/perjawatan",
      name: "perjawatan",
      description: "Art Director",
      ctrl: "perjawatan",
      submenu: [
        {
          title: "Perjawatan (Muat Naik)",
          name: "muat-turun",
          link: "/perkhidmatan/perjawatan/muat-turun",
        },
        {
          title: "Senarai Transaksi Perjawatan",
          name: "transaksi-perjawatan",
          link: "/perkhidmatan/perjawatan/transaksi-perjawatan",
        }
      ],
    },

    {
      icon: "/media/icons/duotune/general/gen049.svg",
      color: "success",
      title: "Pegawai JANM",
      link: "/perkhidmatan/pegawai_janm",
      name: "pegawailist",
      description: "Art Director",
      ctrl: "pegawai_janm",
    },
    {
      icon: "/media/icons/duotune/general/gen041.svg",
      color: "danger",
      title: "Pengumuman",
      link: "/perkhidmatan/pentadbiran/pengumuman",
      name: "pengumuman-perkhidmatan",
      description: "Art Director",
      ctrl: "perkhidmatan_hebahan",
    },
    {
      icon: "/media/icons/duotune/general/gen004.svg",
      color: "danger",
      title: "Semak Data Hrmis",
      link: "/perkhidmatan/hrmis/data",
      name: "perkhidmatan-hrmis-data",
      description: "Art Director",
      ctrl: "perkhidmatan_semak_data_hrmis",
    },
    {
      icon: "/media/icons/duotune/files/fil009.svg",
      color: "danger",
      title: "Manual Pentadbir",
      link: "/perkhidmatan/manual/pentadbir",
      name: "perkhidmatan-manual-pentadbir",
      description: "Art Director",
      ctrl: "perkhidmatan_manual",
    },
  ];



export const PeperiksaanMenuItems = [
    {
      icon: "/media/icons/duotune/abstract/abs027.svg",
      color: "success",
      title: "Dashboard",
      link: "/#/peperiksaan/dashboard",
      name: "peperiksaan-dashboard",
      description: "Project Manager",
      ctrl: "peperiksaan_dashboard",
    },
    {
      icon: "/media/icons/duotune/art/art005.svg",
      color: "warning",
      title: "Takwim",
      link: "/#/peperiksaan/takwim",
      name: "takwim",
      description: "Art Director",
      ctrl: "peperiksaan_takwim",
    },
    {
      icon: "/media/icons/duotune/communication/com012.svg",
      color: "primary",
      title: "Urusan Keputusan Peperiksaan",
      link: "/#/peperiksaan/urusan",
      name: "keputusanlist",
      description: "Lead Developer",
      ctrl: "peperiksaan_keputusan",
    },
    {
      icon: "/media/icons/duotune/general/gen017.svg",
      color: "danger",
      title: "Pengurusan Rayuan",
      link: "/#/peperiksaan/rayuan",
      name: "pengurusan-rayuan",
      description: "Lead Developer",
      ctrl: "peperiksaan_rayuan",
    },
    {
      icon: "/media/icons/duotune/general/gen049.svg",
      color: "primary",
      title: "Sejarah Permohonan",
      link: "/#/peperiksaan/pemohon",
      name: "userlist",
      description: "Lead Developer",
      ctrl: "peperiksaan_sejarah_permohonan",
    },
    {
      icon: "/media/icons/duotune/general/gen043.svg",
      color: "primary",
      title: "Pengumuman",
      link: "/#/peperiksaan/pentadbiran/pengumuman",
      name: "pengumuman-peperiksaan",
      description: "Lead Developer",
      ctrl: "peperiksaan_hebahan",
    },
    {
      icon: "/media/icons/duotune/general/gen049.svg",
      color: "primary",
      title: "Sejarah Keputusan",
      link: "/#/peperiksaan/pentadbiran/keputusan",
      name: "sejarah-keputusan",
      description: "Lead Developer",
      ctrl: "peperiksaan_sejarah_keputusan",
    },
    {
      icon: "/media/icons/duotune/files/fil009.svg",
      color: "danger",
      title: "Manual Pentadbir",
      link: "/peperiksaan/manual/pentadbir",
      name: "peperiksaan-manual-pentadbir",
      description: "Art Director",
      ctrl: "peperiksaan_manual",
    },
  ];

export const PsmMenuItems = [
    {
        ctrl: 'psm_dashboard',
        icon: "/media/icons/duotune/abstract/abs027.svg",
        link: '/psm/dashboard',
        name: 'psm-dashboard',
        submenu: [],
        title: 'Dashboard',
    },
  //   {
  //     ctrl: 'psm_pemetaan',
  //     icon: "/media/icons/duotune/abstract/abs027.svg",
  //     link: '/psm/pemetaan',
  //     name: 'psm-pemetaan',
  //     submenu: [],
  //     title: 'Pemetaan PSM',
  // },
];

export const SistemMenuItems = DocMenuConfig;
export const LaporanMenuItems = LaporanMenuConfig;
